import React from 'react'

const Privacy_policy = () => {
  return (
    <div className="container my-5">
    <div className="card shadow border-0 p-4">
      <h2 className="text-center mb-4 fw-bold text-primary">Privacy Policy</h2>

      <p className="text-muted mb-4">
        <strong>Dartex Technology Private Limited</strong> (Dartex, “we”,
        “our”, or “us”) respects your privacy and is committed to protecting your
        personal and business information. This Privacy Policy explains how we
        collect, use, and safeguard your data when you use our platform and services.
      </p>

      <section className="mb-4">
        <h5 className="fw-semibold">1. Information We Collect</h5>
        <p className="mt-2">
          We may collect the following information when you sign up or use Dartex:
        </p>
        <ul>
          <li>
            <strong>Seller details:</strong> Name, business name, GST number, PAN, KYC
            documents, and bank details
          </li>
          <li>
            <strong>Contact details:</strong> Email, phone number, address
          </li>
          <li>
            <strong>Order details:</strong> Customer name, shipping address, contact
            number, order value, payment method (COD/Prepaid)
          </li>
          <li>
            <strong>Usage data:</strong> Login information, device/browser details, and
            activity on our platform
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">2. How We Use Your Information</h5>
        <ul className="mt-2">
          <li>Provide and manage courier services</li>
          <li>Process COD and payment settlements</li>
          <li>Improve our platform and services</li>
          <li>Communicate updates, service changes, or promotions</li>
          <li>Ensure compliance with courier and government regulations</li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">3. Data Sharing</h5>
        <ul className="mt-2">
          <li>
            We share necessary shipping details (recipient name, address, phone number,
            order value, etc.) with courier partners only to fulfill deliveries.
          </li>
          <li>
            We do not sell, rent, or trade your data with third parties for marketing
            purposes.
          </li>
          <li>
            Data may be shared with legal or regulatory authorities if required by law.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">4. Data Security</h5>
        <ul className="mt-2">
          <li>
            We use secure servers, encryption, and restricted access controls to
            safeguard your data.
          </li>
          <li>
            While we follow best practices, no online platform can guarantee 100% data
            security. Sellers are advised to keep login credentials safe.
          </li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">5. Cookies & Tracking</h5>
        <p className="mt-2">
          Our website and dashboard may use cookies and analytics tools to improve user
          experience, track performance, and enhance services.
        </p>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">6. Data Retention</h5>
        <p className="mt-2">
          We retain seller and shipping data as long as it is necessary for business,
          legal, or compliance purposes.
        </p>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">7. Your Rights</h5>
        <ul className="mt-2">
          <li>
            You may request correction or deletion of your personal data (subject to
            legal and operational requirements).
          </li>
          <li>You may opt out of promotional communications anytime.</li>
        </ul>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">8. Third-Party Links</h5>
        <p className="mt-2">
          Our platform may contain links to third-party websites. Dartex is not
          responsible for the privacy practices of external sites.
        </p>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">9. Changes to Policy</h5>
        <p className="mt-2">
          We may update this Privacy Policy from time to time. Updates will be posted on
          our website and notified via email or dashboard alerts.
        </p>
      </section>

      <section className="mb-4">
        <h5 className="fw-semibold">10. Contact Us</h5>
        <p className="mt-2 mb-0">
          For any privacy-related queries, please contact:
        </p>
        <ul className="list-unstyled mt-2">
          <li><strong>Dartex Technology Private Limited</strong></li>
          <li>Email: <a href="mailto:support@dartex.com">support@dartex.com</a></li>
          {/* <li>Phone: 8128857546</li> */}
          <li>Website: <a href="https://www.dartex.in" target="_blank" rel="noreferrer">www.dartex.in</a></li>
        </ul>
      </section>

      <p className="text-muted mt-4">
        By using Dartex, you agree to the terms of this{" "}
        <strong>Privacy Policy</strong>.
      </p>
    </div>
  </div>
  )
}

export default Privacy_policy
